module.exports = __webpack_public_path__ + "img/truewallet.e6f3111b.jpg";